"use strict";function replace$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.replace$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.navigation.replace";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"3.4.6"},_a[ddSdk_1.ENV_ENUM.android]={vs:"3.4.6"},_a)),exports.replace$=replace$,exports.default=replace$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/navigation/replace.js
// module id = 974
// module chunks = 106